import { useQuery } from '@apollo/client';

import { useParams } from 'js/lib/useRouter';

import specializationReviewsPageQuery from 'bundles/reviews/queries/SpecializationReviewsPage.graphql';
import type {
  SpecializationReviewsPageDataFragment,
  SpecializationReviewsPageQuery,
  SpecializationReviewsPageQueryVariables,
} from 'bundles/reviews/queries/__generated__/SpecializationReviewsPage';

export type SpecializationReviewsPageData = SpecializationReviewsPageDataFragment;

type SpecializationReviewsPageQueryResult = {
  loading: boolean;
  error?: Error;
  reviewsPageData: SpecializationReviewsPageData | null;
};

/**
 * Fetches the real topReviews/ratingCountsByStar for the specialization reviews page via
 * DescriptionPage.querySpecializationReviewsPage. Pass `skip: true` while the
 * `specialization-reviews-layer` experiment's `enableReviews` param is off, since the control
 * group never renders this data.
 */
export function useSpecializationReviewsPageQuery(skip: boolean): SpecializationReviewsPageQueryResult {
  const params = useParams();
  const slug = params?.slug ?? '';

  const { data, loading, error } = useQuery<SpecializationReviewsPageQuery, SpecializationReviewsPageQueryVariables>(
    specializationReviewsPageQuery,
    {
      variables: { slug },
      skip: !slug || skip,
      context: {
        clientName: 'gatewayGql',
      },
    }
  );

  return {
    loading: !skip && !!slug && loading,
    error,
    reviewsPageData: data?.DescriptionPage?.querySpecializationReviewsPage ?? null,
  };
}
